<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>JOB Logs</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblJobLogs"
                    :itens="jobLogs"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    props: {
        jobLogs: {
            type: Array,
            default: () => []
        }
    },
    components: {},

    data() {
        return {
            campos: [
                {
                    key: 'dataInicio',
                    label: 'Data Início',
                    sortable: true,
                    filterable: true,
                    type: 'datetime'
                },
                {
                    key: 'dataFim',
                    label: 'Data Fim',
                    sortable: true,
                    filterable: true,
                    type: 'datetime'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {},

    created() {},

    computed: {},

    watch: {}
}
</script>
